import React from "react";
import { useCartStore } from "../../../store/useCartStore";
import useChanegeCart from "../../../hooks/helper/useChangeCart";
import { numberWithCommas } from "../../../utils/numberWithCommas";

function Order_list() {
  const cart = useCartStore((state) => state.cart);
  const { addToCart, removeFromCart } = useChanegeCart();
  return (
    <div id="order_list_cart" className={cart.length > 0 ? "d-block" : ""}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="order-list">
              {cart.map((order) => {
                let rate = +order.rate;
                let rate_width = (rate * 100) / 5;
                let rate_hide = 100 - rate_width;
                return (
                  <div className="order" key={order.id}>
                    <div className="right">
                      <div className="img-box">
                        <img
                          src={
                            order.photo
                          }
                          alt={order.title}
                          title={order.title}
                          className="img-fluid"
                          style={{
                            width: 200,
                            height: 150,
                            objectFit: "cover",
                          }}
                        />
                      </div>
                      <div className="info-box">
                        <p className="rates">
                          <span className="rate" title={order.rate}>
                            {[...Array(5)].map((star, index) => {
                              return (
                                <i className="fas fa-star" key={index}></i>
                              );
                            })}
                            <span
                              className="show-rate-percent"
                              style={{ width: rate_hide + "%" }}
                            ></span>
                          </span>
                        </p>
                        <h5>{order.title}</h5>
                        <p>{order.excerpt}</p>
                      </div>
                    </div>
                    <div className="left">
                      <div className="quantity">
                        <span
                          className="plus"
                          onClick={() => {
                            addToCart({ ...order });
                          }}
                        >
                          <i className="fas fa-plus"></i>
                        </span>
                        <input
                          className="count"
                          min="1"
                          type="number"
                          value={order.count}
                          readOnly
                        />
                        <span
                          className="minus"
                          onClick={() => {
                            removeFromCart({ ...order });
                          }}
                        >
                          <i className="fas fa-minus"></i>
                        </span>
                      </div>
                      <p className="price">
                        {numberWithCommas(order.price * order.count)}
                        <span className="currency">تومان</span>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Order_list;
